<div class="row">
    <div class="col text-start">
        <b>Copyright</b> ONappli &copy; 2014-{{ currentYear }}
    </div>
    <div
        class="col text-end"
        *ngIf="accountService.connectedUser | async as user"
    >
        Client ID : 12{{ user.Id }}
    </div>
</div>
